export default class Leaderboard {
    constructor(api) {
        this.api = api;
        this.LeaderboardsClass = null;
    }

    async init(instance) {
        if (this.api && this.api.settings && this.api.settings.leaderboardInstance && this.api.settings.leaderboardInstance !== instance.instance) {
            return;
        }

        if (!this.LeaderboardsClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
                // await this.api.util.loadJS(["http://localhost:8081/widget_leaderboard.js"]);
                // await this.api.util.loadJS(["https://cdn.oryxgaming.com/widget/agg_widgets/2020-S13.1/ingame/leaderboard/js/leaderboard.js"]);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.leaderboard &&
                this.api.settings.widgetsUrl.leaderboard.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.leaderboard.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
                // await this.api.util.loadCSS(['https://cdn.oryxgaming.com/widget/agg_widgets/2020-S13.1/ingame/leaderboard/css/leaderboard.css']);
                // await this.api.util.loadCSS(['https://cdn.oryxgaming.com/widget/agg_widgets/2020-S13.1/ingame/leaderboard/css/leaderboard.css']);
                // await this.api.util.loadCSS(['http://localhost:63342/widgets/dist/leaderboard/css/leaderboard.css']);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.leaderboard &&
                this.api.settings.widgetsUrl.leaderboard.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.leaderboard.css]);
            }
        }

        if (window.store) {
            window.store.dispatch('addInstanceToContainer', instance.instance)
            this.createInstance(instance)
        }
    }
    createInstance(instance) {
        if (!document.getElementById(`ox-drawer-instance-container-${instance.instance}-inner`)) {
            setTimeout(()=> {
                this.createInstance(instance)
            },100)
        } else {
            this.LeaderboardsClass = new window.Widget_leaderboard.default(this.api.settings, `#ox-drawer-instance-container-${instance.instance}-inner`, instance.instance, this.api, instance.data.settings);
        }
    }
}
